<template>
    <div class="main-wrap" :class="{playing:state===GAME_STATE.PLAYING, noBackGround:dialogType===5}">
        <div class="mask-dark" :class="{active:gameRankingToggle||gameCertiToggle||gameHelpToggle||(preparedTime>=0&&state===GAME_STATE.PLAYING)||dialogToggle}" @click="checkMaskClicked()"></div>
        <span class='prepared-text' v-show="(preparedTime>=0&&state===GAME_STATE.PLAYING)">{{preparedTime}}</span>
        <transition name="el-fade-in"><span class='hint-text' v-show="(hintText&&state===GAME_STATE.PLAYING)">{{hintText}}</span></transition>
        <transition name="el-fade-in">
            <div class="menu-box" v-show="gameInitToggle">
                <img class='title-img' :src="isDesktop?require(`@/assets/img/title-2.png`):require(`@/assets/img/title-mobile.png`)" alt="">
                <img class='pointer start-img hover' src="@/assets/img/start.png" alt="" @click="switchGameStep(GAME_STATE.FILL_INFORMATION)">
                <img class='pointer ranking-img hover' src="@/assets/img/ranking.png" alt="" @click="gameRankingToggle=true;gameInitToggle=false">
                <img class='pointer help-img hover' src="@/assets/img/help.png" alt="" @click="gameHelpToggle=true;gameInitToggle=false">
            </div>
        </transition>
        <!-- <div style="z-index:99;position: absolute;top:30px;left:30px;background-color:#000;color:#fff;font-size:32px;">FPS: {{fps}}</div> -->
        <transition name="el-fade-in">
            <div class="ranking-box" v-show="gameRankingToggle">
                <div class="ranking-content">
                    <h4>排行榜</h4>
                    <div class="data-box">
                        <div class="data-card">
                            <div class="card-slot pointer" :class="{active: lastClickedTab===1}" @click="clickRankingTab(1)">拼圖一 簡單</div>
                            <div class="card-slot pointer" :class="{active: lastClickedTab===2}" @click="clickRankingTab(2)">拼圖一 困難</div>
                            <div class="card-slot pointer" :class="{active: lastClickedTab===3}" @click="clickRankingTab(3)">拼圖二 簡單</div>
                            <div class="card-slot pointer" :class="{active: lastClickedTab===4}" @click="clickRankingTab(4)">拼圖二 困難</div>
                            <div class="card-slot pointer" :class="{active: lastClickedTab===5}" @click="clickRankingTab(5)">拼圖三 高手</div>
                        </div>
                        <div class="data-item" v-for="item, index in rankingData" :key="item.rData">
                            <div class="index">{{index+1}}</div>
                            <div class="name">{{item.name}}</div>
                            <!-- <div class="">{{item.school}}</div> -->
                            <div class="">{{switchSecondsToTime(item.time)}}</div>
                        </div>
                    </div>
                    <img class='pointer close hover' src="@/assets/img/close.svg" @click="switchGameStep(GAME_STATE.INIT)">
                </div>
            </div>
        </transition>
        <transition name="el-fade-in">
            <div class="form-box" v-show="state===GAME_STATE.FILL_INFORMATION" :class='{hide: dialogToggle}'>
                <div class="form-content">
                    <h3>請輸入個人資料</h3>
                    <div class="input-box">
                        <input type="text" :class='{block: dialogToggle}' v-model='userForm.name' name="name" id="userName" placeholder="你的名字是?">
                        <!-- <input type="text" :class='{block: dialogToggle}' v-model='userForm.school' name="school" id="userSchool" placeholder="你的學校是?">
                        <input type="text" :class='{block: dialogToggle}' v-model='userForm.grade' name="grade" id="userGrade" placeholder="你的年級是?"> -->
                    </div>
                    <button class="pointer hover" :class='{block: dialogToggle}' @click="switchGameStep(GAME_STATE.CHOOSE_DIFFICULTY)">我設定好了！</button>
                </div>
                <img src="@/assets/img/back.svg" :class="{active: dialogToggle}" class="back pointer hover" @click="switchGameStep(GAME_STATE.INIT)">
            </div>
        </transition>
        <transition name="el-fade-in">
            <div class="diff-box" v-show="state===GAME_STATE.CHOOSE_DIFFICULTY">
                <div class="diff-content">
                    <h3>歡迎<span style="color:#c96100;margin-left:10px;">{{this.userForm.name}}</span>，請選擇想挑戰的難度</h3>
                    <div class="diff-img-content">
                        <div class="diff-img">
                            <h4>拼圖一</h4>
                            <div class="item">
                                <img src="@/assets/img/diff-1.png" alt="">
                                <div class="btn-box">
                                    <button class='hover' @click="gameType=1;difficulty=1;switchGameStep(GAME_STATE.PLAYING);">簡單</button>
                                    <button class='hover' @click="gameType=1;difficulty=2;switchGameStep(GAME_STATE.PLAYING);">困難</button>
                                </div>
                            </div>
                        </div>
                        <div class="diff-img">
                            <h4>拼圖二</h4>
                            <div class="item">
                                <img src="@/assets/img/diff-2.png" alt="">
                                <div class="btn-box">
                                    <button class='hover' @click="gameType=2;difficulty=1;switchGameStep(GAME_STATE.PLAYING);">簡單</button>
                                    <button class='hover' @click="gameType=2;difficulty=2;switchGameStep(GAME_STATE.PLAYING);">困難</button>
                                </div>
                            </div>
                        </div>
                        <div class="diff-img">
                            <h4 class="sp">混合拼圖</h4>
                            <div class="item">
                                <img src="@/assets/img/diff-3.png" alt="">
                                <div class="btn-box">
                                    <button class="sp hover" @click="gameType=3;difficulty=1;switchGameStep(GAME_STATE.PLAYING);">高手</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="@/assets/img/back.svg" alt="" class="back pointer hover" @click="switchGameStep(GAME_STATE.FILL_INFORMATION)">
            </div>
        </transition>
        <transition name="el-fade-in">
            <div class="help-box" v-show="gameHelpToggle">
                <h4>遊戲說明</h4>
                <div class="help-content">
                    <div class="left-box">
                        <img src="@/assets/img/help-img.png" alt="">
                    </div>
                    <div class="right-box">
                        <div class="target-group">
                            <h3 class="first">遊戲目標：</h3>
                            <span>嘗試在最短時間內拼完所選擇難度的拼圖，讓圖片能完整呈現。</span>
                        </div>
                        <div class="intro-group">
                            <h3>遊戲說明：</h3>
                            <ul>
                                <li>進入遊戲前，請填寫基本資料。</li>
                                <li>選擇想嘗試的拼圖圖片及困難度。</li>
                                <li>進入遊戲後，開始進行拼圖遊戲，並開始計時。</li>
                                <li>完成後，會顯示一張挑戰完成的獎狀，可存取圖片收集。</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <button class="pointer hover" @click="switchGameStep(GAME_STATE.INIT)">我知道了</button>
                </div>
                <img class='pointer close hover' src="@/assets/img/close.svg" @click="switchGameStep(GAME_STATE.INIT)">
            </div>
        </transition>
        <transition name="el-fade-in">
            <div v-show='hintImageToggle' class="hint-mask" @click="hintImageToggle=false">
                <img :src="puzzleImage" alt="">
            </div>
        </transition>
        <transition name="el-zoom-in-center">
            <div class="canvas-wrap" id='phaser-container' v-show="state===GAME_STATE.PLAYING" :class="{dialog:dialogToggle}">
                    <div class="left-btn" :class="{active: preparedTime>0||dialogToggle}">
                        <img src="@/assets/img/back.svg" alt="" class="pointer hover" @click="showDialog(`返回後紀錄會消失，確定要返回嗎？`, 1)">
                        <img src="@/assets/img/home.svg" alt="" class="pointer hover" @click="showDialog(`確定要回首頁嗎？`, 2)">
                    </div>
                    <div class="right-btn" :class="{active: preparedTime>0||dialogToggle}">
                        <img src="@/assets/img/again.svg" alt="" class="pointer hover i1" @click="showDialog(`確定要重新挑戰嗎？`, 3)">
                        <img src="@/assets/img/hint.svg" alt="" class="pointer hover i2" @click="hintImageToggle=true">
                        <img src="@/assets/img/give-up.svg" alt="" class="pointer hover i3" @click="showDialog(`確定要結束遊戲嗎？`, 4)">
                    </div>
                    <div class="timer" :class="{active:preparedTime>0||dialogToggle}">
                        {{playTime}}
                        <img src="@/assets/img/timer.svg" alt="">
                    </div>
            </div>
        </transition>
        <transition name="el-zoom-in-center">
            <div class="dialog-box" v-show="dialogToggle">
                <div class="dialog-container">
                    <h4>{{dialogTitle}}</h4>
                    <div class="btn-box">
                        <button class="pointer hover" @click="checkDialogConfirmation();">確定</button>
                        <button class="pointer" v-show="dialogType!==5  " @click="dialogToggle=false">取消</button>
                    </div>
                </div>
                <img src="@/assets/img/close.svg" alt="" class="pointer hover" @click="dialogToggle=false">
            </div>
        </transition>
        <transition name="el-zoom-in-center">
            <div class="certi-box" v-show="gameCertiToggle" :class="{redirect: gameRedirectToggle}">
                <div class="certi-container" v-show="!gameRedirectToggle">
                    <img class='reward-img' id='reward-img' alt="">
                    <img class='congrat-img' src="@/assets/img/congrat.png" alt="">
                    <!-- <h3>恭喜 {{userForm.school}} {{userForm.grade}}年級 <span style="color:#c96100">{{userForm.name}} </span>同學，完成挑戰！</h3> -->
                    <h3>恭喜 <span style="color:#c96100">{{userForm.name}} </span>水保小尖兵，完成挑戰！</h3>
                    <div class="info-box">
                        <div class="img" id="congrat-game-img"></div>
                        <div class="info">
                            <div class="detail">
                                <span>
                                    {{puzzleName}}
                                </span>
                                <span>
                                    &nbsp;&nbsp;&nbsp;{{puzzleDiff}}
                                </span>
                            </div>
                            <div class="time-box">
                                <span>花費時間</span>
                                <span style="font-size:40px;margin-top:5px">{{playTime}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="btn-box">
                        <button class="pointer hover" @click="redirectGameStep(1)">回首頁</button>
                        <button class="pointer hover" @click="redirectGameStep(2)">重新挑戰</button>
                        <transition name="el-zoom-in-center">
                            <div class="lds-ellipsis" v-show="gameRedirectToggle"><div></div><div></div><div></div><div></div></div>
                        </transition>
                    </div>
                </div>
            </div>
        </transition>
        <div class="game-prog">{{gameProgress}}</div>
        <div class="" @click="switchGameStep(GAME_STATE.ENDING)" style="display:none;position:absolute;top: 50px;left:50px;background-color:white">CLICK Me</div>
    </div>
</template>
<script>
import axios from 'axios';
import 'phaser';
let PHASER_INSTANCE;
export default {
    data() {
        return {
            fps: 99,
            gameInitToggle: true,
            gameHelpToggle: false,
            gameRankingToggle: false,
            gameDiffToggle: false,
            gameCertiToggle: false,
            gameRedirectToggle: false,
            dialogToggle: false,
            userForm:{
                name: '',
                school: 'undefined',
                grade: 'undefined',
            },
            state: 0,
            difficulty: 1,//1 or 2
            gameType: 1,
            playTime: "00:01",
            preparedTime: 1,
            dialogTitle: '',
            dialogType: 1,
            logoQueuing: false,
            GAME_STATE: Object.freeze({
                "INIT": 0,
                "FILL_INFORMATION": 1,
                "CHOOSE_DIFFICULTY": 2,
                "PLAYING": 3,
                "ENDING": 4,
            }),
            rankingData:[
                {
                    name: 'fakeData.Name',
                    school: 'fakeData.School',
                    time: 'fakeData.Time'
                },
            ],
            lastClickedTab: 1,
            gameProgress: '0/0',
            draggingScene: false,
            draggingPiece: false,
            hintText: '',
            hintImageToggle: false,
        }
    },
    methods:{
        getGameLevel(){
            switch (this.gameType) {
                case 1:
                    return (this.difficulty===1)?1:2;
                case 2:
                    return (this.difficulty===1)?3:4;
                case 3:
                    return 5;
                default:
                    return 0;
            }
        },
        getData(){
            // console.log(this.getGameLevel());
            axios.get(`https://bkhole.app/jigsaw-puzzles?level=${this.lastClickedTab}`,{
                params:{
                    _sort: 'time',
                    _limit: 3,
                }
            })
            .then((res)=>{
                this.rankingData = res.data;
                const intervalLength = 3 - this.rankingData.length;
                if(intervalLength > 0){
                    for(let i=0;i<intervalLength;i++){
                        this.rankingData.push({
                            name: '無',
                            school: '',
                            grade: '',
                            time: -1,
                        })
                    }
                }
            })
            .catch((err)=>{
            })
        },
        postData(){
            axios.post('https://bkhole.app/jigsaw-puzzles',{
                name: this.userForm.name,
                school: this.userForm.school,
                level: this.getGameLevel(),
                grade: this.userForm.grade,
                time: this.switchTimeToSeconds(this.playTime),
            }).then(res=>{
                console.log('post data res, ', res);
            }).catch(err=>{
                console.log('Some err happened!, ', err);
            })
        },
        switchGameStep(step=-1){
            if(step===-1) return;
            this.clearUI();
            this.clearPhaserInstance();
            const vm = this;
            switch (step) {
                case this.GAME_STATE.INIT:
                    this.gameInitToggle = true;
                    break;
                case this.GAME_STATE.FILL_INFORMATION:
                    break;
                case this.GAME_STATE.CHOOSE_DIFFICULTY:
                    if(!this.userForm.name||!this.userForm.school||!this.userForm.grade){
                        this.showDialog('請填寫所有的欄位哦！', 5)
                        return;
                    }
                    this.difficultyToggle = true;
                    break;
                case this.GAME_STATE.PLAYING:
                    //here can be firet play and replay, so dont change difficulty and gameType.
                    this.preparedTime = 5;
                    this.playTime = "00:00";
                    this.initPhaser();
                    break;
                case this.GAME_STATE.ENDING:
                    document.getElementById('congrat-game-img').style.backgroundImage = `url(${require(`@/assets/img/diff-${this.gameType}.png`)})`;
                    document.getElementById('reward-img').src = this.getRankingCompareToData()>0?require(`@/assets/img/reward-${this.getRankingCompareToData()}.png`):"";
                    this.gameCertiToggle = true;
                    this.logoQueuing = true;
                    this.postData();
                    setTimeout(()=>{
                        if(!this.logoQueuing){
                            return;
                        }
                        this.redirectGameStep();
                    }, 6000);
                    break;
                default:
                    break;
            }
            this.state = step;
        },
        redirectGameStep(id){
            this.gameRedirectToggle = true;
            this.logoQueuing = false;
            const vm = this;
            setTimeout(()=>{
                if(id===2){
                    vm.switchGameStep(vm.GAME_STATE.PLAYING);
                }else{
                    vm.switchGameStep(vm.GAME_STATE.INIT);
                }
            }, 5000)
        },
        getRankingCompareToData(){
            let s = this.switchTimeToSeconds(this.playTime);
            if (s < this.rankingData[0].time) return 1
            else if(s < this.rankingData[1].time) return 2;
            else if(s < this.rankingData[2].time) return 3;
            else return -1;
        },
        switchTimeToSeconds(secString){
            const min = secString.split(':')[0];
            const sec = secString.split(':')[1];
            return parseInt(min)*60 + parseInt(sec);
        },
        switchSecondsToTime(seconds){
            //Data form - "mm:ss"
            if(typeof(seconds)!=='number') return;
            return new Date(seconds * 1000).toISOString().substr(14, 5);
        },
        clearUI(){
            this.gameInitToggle = false;
            this.gameHelpToggle = false;
            this.gameRankingToggle = false;
            this.gameDiffToggle = false;
            this.gameCertiToggle = false;
            this.gameRedirectToggle = false;
            this.dialogType = 1;
        },
        clearPhaserInstance(){
            if(PHASER_INSTANCE){
                PHASER_INSTANCE.destroy(true);
            }
        },
        showDialog(title='',type=1){
            this.dialogToggle = true;
            this.dialogTitle = title;
            this.dialogType = type;
        },
        checkMaskClicked(){
            switch (this.state) {
                case this.GAME_STATE.PLAYING:
                    this.dialogToggle = false;
                    break;
                case this.GAME_STATE.INIT:
                    this.switchGameStep(this.GAME_STATE.INIT);
                    break;
                default:
                    break;
            }
        },
        checkDialogConfirmation(){
            switch (this.dialogType) {
                case 1:
                    this.switchGameStep(this.GAME_STATE.CHOOSE_DIFFICULTY);
                    break;
                case 2:
                    this.switchGameStep(this.GAME_STATE.INIT);
                    break;
                case 3:
                    this.switchGameStep(this.GAME_STATE.PLAYING);
                    break;
                case 4:
                    this.switchGameStep(this.GAME_STATE.INIT);
                    break;
                case 5:
                    //fill information hint
                    break;
                default:
                    break;
            }
            this.dialogToggle = false;
        },
        clickRankingTab(id){
            this.lastClickedTab = id;
            this.getData();
        },
        initPhaser(){
            let vm = this;
            const difficulty = vm.difficulty;
            const gameType = vm.gameType;
            const side = difficulty===2||gameType===3?8:5;
            const piecesWidth = 700 / side;
            const piecesHeight = 496 / side;
            PHASER_INSTANCE = new Phaser.Game({
                type: Phaser.WEBGL,
                scale:{
                    width: window.innerWidth,
                    height: window.innerHeight,
                    autoCenter: Phaser.Scale.CENTER_BOTH,
                    mode: Phaser.Scale.RESIZE,
                },
                backgroundColor: '#efefef',
                parent: 'phaser-container',
                scene:{
                    preload: preload,
                    create: create,
                },
                // fps: {
                //     target: 60,
                //     forceSetTimeOut: true
                // },
            });
            function preload(){
                //images
                this.load.spritesheet('puzzle-1', require('@/assets/img/puzzle1-700.png'), {frameWidth: 700/side, frameHeight: 496/side});
                this.load.spritesheet('puzzle-2', require('@/assets/img/puzzle2-700.png'), {frameWidth: 700/side, frameHeight: 496/side});
                this.load.image('wood', require('@/assets/img/wood.png'));
                this.load.image('solved', require('@/assets/img/solved.svg'));
                this.load.image('solved-img', 'static/img/solved.png');
                this.load.image('i1', require('@/assets/img/puzzle1-700.png'));
                this.load.image('i2', require('@/assets/img/puzzle2-700.png'));
                this.load.image('put-here-hint', require('@/assets/img/hint-put-here.png'));
                //plugins
                this.load.scenePlugin({
                    key: 'rexgesturesplugin',
                    url: 'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexgesturesplugin.min.js',
                    sceneKey: 'rexGestures'
                });
            };
            function create(){
                let scene = this;
                let camera = this.cameras.main;
                let start = false, isPuzzleSet = false;
                let readyTime = 7;
                let seconds = 0;
                let p1 = null, p2 = null;
                let i1 = null, i2 = null;

                let bg = this.add.image(0,0,'wood').setOrigin(0);
                
                this.time.addEvent({ 
                    delay: 1000, 
                    callback: onPerSecond, callbackScope: this, loop: true 
                });
                setCamera();
                setControls();
                function onPerSecond(){
                    if(vm.preparedTime > 0){
                        vm.preparedTime--;
                        return;
                    }else{
                        if(readyTime){
                            if(gameType===3){
                                if(!i1) i1 = scene.add.image(getOffset().x1, getOffset().y, 'i1').setOrigin(0).setDepth(5);
                                if(!i2) i2 = scene.add.image(getOffset().x2, getOffset().y, 'i2').setOrigin(0).setDepth(5);
                            }else{
                                if(!i1) i1 = scene.add.image(getOffset().x, getOffset().y, gameType===1?'i1':'i2').setOrigin(0).setDepth(5);
                            }
                            switch(readyTime){
                                case 7:
                                    vm.hintText = '要好好記住圖案喔！'
                                    break;
                                case 6:
                                    vm.hintText = '要開始囉！'
                                    break;
                                default:
                                    vm.hintText = readyTime;
                                    break;
                            }
                            if(!isPuzzleSet){
                                setPuzzle();
                                isPuzzleSet = true;
                            }
                            vm.preparedTime = -1;
                            readyTime--;
                        }else{
                            if(!start){
                                p1?.setPieces();
                                p2?.setPieces();
                                i1?.destroy();
                                i2?.destroy();
                                start = true;
                                vm.hintText = '';
                            }else{
                                seconds++;
                                vm.playTime = vm.switchSecondsToTime(seconds);
                            }
                        }
                    }
                }
                function setCamera(){
                    camera.setBounds(bg.getBounds().left, bg.getBounds().top, bg.getBounds().width, bg.getBounds().height);
                    camera.setZoom(document.getElementById('phaser-container').offsetWidth > 1600 ? 1 : 0.8);
                    if(document.getElementById('phaser-container').offsetWidth > 2048){
                        camera.setZoom(3);
                    }
                    camera.setOrigin(0.5);
                    camera.centerOn(960, 540);
                    window.camera = camera;
                };
                function getOffset(){
                    const innerOffset = 50, yOffset = 50;
                    return {
                        x: 1920/2 - 700/2,
                        y: 1080/2 - 496/2,
                        x1: bg.getBounds().width/2 - innerOffset - 700,
                        x2: bg.getBounds().width/2 + innerOffset,
                    }
                }
                function setPuzzle(){
                    if(gameType===3){
                        p1 = new Puzzle(1, 'puzzle-1', getOffset().x1, getOffset().y, side);
                        p2 = new Puzzle(2, 'puzzle-2', getOffset().x2, getOffset().y, side);
                    }else{
                        p1 = new Puzzle(1, gameType===1?'puzzle-1':'puzzle-2', getOffset().x, getOffset().y, side);
                    }
                };
                class Puzzle {
                    constructor(id, puzzleKey, x, y, side) {
                        this.id = id;//puzzle1 or puzzle2
                        this.puzzleKey = puzzleKey;
                        this.side = side;
                        this.pieces = [];
                        this.grids = [];
                        this.solvedPuzzles = 0;
                        this.showHint = true;
                        this.x = x;
                        this.y = y;
                        this.layout = null;
                        this.setLayout();
                        this.setGrids();
                        this.setHint();
                        this.setTitle();
                    }
                    downplay(){
                        this.grids.forEach(e=>{e.alpha=0.3});
                        this.layout.alpha = 0.3;
                        this.hint.alpha = 0.3;
                    }
                    highlight(){
                        this.grids.forEach(e=>{e.alpha=1.0});
                        this.layout.alpha = 1.0;
                        this.hint.alpha = 1.0;
                    }
                    setLayout(){
                        this.layout = scene.add.rectangle(this.x, this.y, 700, 496, Phaser.Display.Color.HexStringToColor('#ebebeb').color)
                        .setOrigin(0)
                        .setStrokeStyle(7, Phaser.Display.Color.HexStringToColor('#c2a979').color);
                    }
                    setTitle(){
                        scene.add.text(this.x + 350, this.y - 100, this.puzzleKey==='puzzle-1'?"拼圖一":"拼圖二", {
                            fontFamily: 'Noto Sans TC',
                            fontSize: 60,
                            color: "#000000",
                        }).setOrigin(0.5, 0);
                    }
                    setHint(){
                        this.hint = scene.add.image(this.x + 350, this.y + 248, 'put-here-hint').setOrigin(0.5, 0.5);
                    }
                    setGrids(){
                        let count = 1;
                        for (let y = 0; y < this.side; y++) {
                            for (let x = 0; x < this.side; x++) {
                                this.grids.push(new Grids(this.id, this.side, x, y, piecesWidth, piecesHeight, count++));
                            }
                        }
                    }
                    setPieces(){
                        let count = 1;
                        for (let x = 0; x < this.side; x++) {
                            for (let y = 0; y < this.side; y++) {
                                let pos = randomPos();
                                this.pieces.push(new Piece(this.id, pos.x, pos.y, this.puzzleKey, count++));
                            }
                        }
                        function randomPos(){
                            let x, y;
                            while(true){
                                x = Phaser.Math.Between(30, 1700);
                                y = Phaser.Math.Between(50, 920);
                                if(gameType===3){
                                    //puzzle1
                                    if(overlaps(
                                        {x1: x, x2: x + piecesWidth, y1: y, y2: y + piecesHeight},
                                        {x1: getOffset().x1, x2: getOffset().x1+700, y1: getOffset().y, y2: getOffset().y+496}
                                    )){
                                        continue;
                                    }
                                    //puzzle2
                                    if(overlaps(
                                        {x1: x, x2: x + piecesWidth, y1: y, y2: y + piecesHeight},
                                        {x1: getOffset().x2, x2: getOffset().x2+700, y1: getOffset().y, y2: getOffset().y+496}
                                    )){
                                        continue;
                                    }
                                    return {x:x, y:y};
                                }
                                else
                                {
                                    if(overlaps(
                                        {x1: x, x2: x + piecesWidth, y1: y, y2: y + piecesHeight},
                                        {x1: getOffset().x, x2: getOffset().x+700, y1: getOffset().y, y2: getOffset().y+496}
                                    )){
                                        continue;
                                    }
                                    return {x:x, y:y};
                                }
                            }
                            function overlaps(a, b) {
                                if (a.x1 >= b.x2 || b.x1 >= a.x2) return false;
                                if (a.y1 >= b.y2 || b.y1 >= a.y2) return false;
                                return true;
                            }
                        }
                    }
                }
                class Piece{
                    constructor(pid, x, y, puzzleKey, id){
                        this.x = x//x, y
                        this.y = y;
                        this.id = id;
                        this.pid = pid;
                        this.puzzleKey = puzzleKey;
                        this.dragging = false;
                        this.solved = false;
                        this.attachedGrid = null;
                        this.pos = {
                            x: x,
                            y: y,
                        };
                        this.obj = null;
                        this.setObject();
                    }
                    setObject(){
                        this.obj = scene.add.sprite(this.pos.x, this.pos.y, this.puzzleKey, this.id-1)
                        .setOrigin(0)
                        .setDepth(3)
                        .setInteractive();
                        scene.input.setDraggable(this.obj);
                        this.obj.class = this;
                        this.obj.id = this.id-1;
                        // return piece;
                    }
                }
                class Grids {
                    constructor(pid, side, x, y, w, h, id) {
                        this.side = side;
                        this.x = x;//iterator x
                        this.y = y;//iterator y
                        this.pos = {
                            x: (gameType===3)?(pid===1)?(getOffset().x1):(getOffset().x2):getOffset().x,
                            y: getOffset().y+h*y,
                        }
                        this.w = w;
                        this.h = h;
                        this.id = id;//grid index
                        this.pid = pid;//puzzle id
                        this.attached = false;
                        this.solved = false;
                        this.setPosition();
                    }
                    setPosition(){
                        const x0 = (vm.gameType===3)?(this.pid===1)?(getOffset().x1):(getOffset().x2):getOffset().x;
                        this.pos.x = x0+this.w*this.x;
                        this.pos.y = getOffset().y+this.h*this.y;
                        scene.add.rectangle(this.pos.x, this.pos.y, this.w, this.h)
                        .setOrigin(0)
                        .setStrokeStyle(2, Phaser.Display.Color.HexStringToColor('#c2a979').color);
                    }
                }
                function attachToClosestGrid(p){
                    let minimize = (vm.difficulty===2) || vm.gameType===3;
                    let closestGrid = findClosestGrid(p.pid, p.obj.x,p.obj.y,minimize?20:35);
                    if(closestGrid!==null){
                        if(!closestGrid.attached){
                            p.obj.x = closestGrid.pos.x;
                            p.obj.y = closestGrid.pos.y;
                            p.attachedGrid = closestGrid;
                            closestGrid.attached = true;
                            checkSolvedPuzzle(p.pid, p.id);
                        }
                        // console.log('closest g: ', closestGrid);
                    }else{
                        // console.log('not found', p.obj.x, p.obj.y);
                    }
                }
                function checkSolvedPuzzle(pid, id){
                    const puzzle = pid===1 ? p1 : p2;
                    const pieces = pid===1 ? p1.pieces : p2.pieces;
                    const grids = pid===1 ? p1.grids : p2.grids;
                    let p = pieces.find(e=>e.id===id);
                    let g = grids.find(e=>e.id===id);
                    if(isPieceInCorrectGrid(p,g)){
                        puzzle.solvedPuzzles++;
                        p.solved = true;
                        g.solved = true;
                        p.obj.setDepth(1);
                        scene.add.image(p.obj.x, p.obj.y, 'solved-img').setOrigin(0).setDepth(2);
                        // console.log(`進度: ${puzzle.solvedPuzzles}/${side**2}`);
                        checkIfGameFinished();
                    }
                }
                function isPieceInCorrectGrid(p, g){
                    const minimumErrDistance = 1;
                    // console.log(p, g);
                    // return false;
                    return (Math.abs(p.obj.x - g.pos.x) < minimumErrDistance) && (Math.abs(p.obj.y - g.pos.y) < minimumErrDistance)
                }
                function findClosestGrid(pid,x=0,y=0,minimumErrDistance=1){
                    const grids = pid===1? p1.grids : p2.grids;
                    for(let i=0;i<grids.length;i++){
                        let g = grids[i];
                        if(g.solved) continue;
                        if((Math.abs(g.pos.x + g.w/2 - x) < minimumErrDistance) && (Math.abs(g.pos.y + g.h/2 - y) < minimumErrDistance)){
                            return g;
                        }
                        if((Math.abs(g.pos.x - x) < minimumErrDistance) && (Math.abs(g.pos.y - y) < minimumErrDistance)){
                            return g;
                        }
                    }
                    return null;
                }
                function checkIfGameFinished(){
                    if(gameType===3){
                        if(p1.solvedPuzzles===(side**2)&&p2.solvedPuzzles===(side**2)){
                            vm.switchGameStep(vm.GAME_STATE.ENDING);
                        }
                    }else{
                        if(p1.solvedPuzzles===side**2){
                            vm.switchGameStep(vm.GAME_STATE.ENDING);
                        }
                    }
                }
                function setControls(){
                    //mouse wheel event
                    const minZoomValue = document.getElementById('phaser-container').offsetWidth > 1600 ? 1:0.8;
                    let lastDragPos;
                    scene.input.on('wheel', function (pointer, gameObjects, deltaX, deltaY, deltaZ) {
                        camera.zoom += deltaY * -0.01;
                        if(camera.zoom > 2) camera.zoom = 2;
                        if(camera.zoom < 0.8) camera.zoom = minZoomValue;
                    });
                    //mouse drag event
                    scene.rexGestures.add.rotate()
                    .on('drag1', function (rotate) {
                        if(vm.draggingPiece) return;
                        let dragVector = rotate.drag1Vector;
                        scene.cameras.main.scrollX += dragVector.x*-1;
                        scene.cameras.main.scrollY += dragVector.y*-1;
                        vm.draggingScene = true;
                    })
                    .on('drag1end',()=>{
                        vm.draggingScene = false;
                    })
                    //drag event
                    scene.input.on('dragstart', function (pointer, gameObject) {
                        if(gameObject.class.solved) return;
                        vm.draggingPiece = true;
                        gameObject.alpha = 0.3;
                        gameObject.setDepth(6);
                        lastDragPos = {x: gameObject.x, y: gameObject.y};
                        puzzleHighlight(gameObject);
                    });
                    scene.input.on('drag', function (pointer, gameObject, dragX, dragY) {
                        if(gameObject.class.solved) return;
                        gameObject.x = dragX;
                        gameObject.y = dragY;
                    });
                    scene.input.on('dragend', function (pointer, gameObject) {
                        if(gameObject.class.solved) return;
                        if(gameObject.class.attachedGrid!==null){
                            gameObject.class.attachedGrid.attached = false;
                        }
                        if(gameObject.x < 30 || gameObject.x > 1800 || gameObject.y < 50 || gameObject.y > 930){
                            gameObject.setPosition(lastDragPos.x, lastDragPos.y);
                        }
                        gameObject.alpha = 1;
                        gameObject.setDepth(3);
                        gameObject.setOrigin(0,0);
                        vm.draggingPiece = false;
                        puzzleOutlineResume();
                        attachToClosestGrid(gameObject.class);
                    });
                    function puzzleHighlight(gameObject){
                        if(gameType!==3) return;
                        if(gameObject.class.pid===1){
                            p1.highlight();
                            p2.downplay();
                        }else{
                            p1.downplay();
                            p2.highlight();
                        }
                    }
                    function puzzleOutlineResume(){
                        if(gameType!==3) return;
                        p1?.highlight();
                        p2?.highlight();
                    }
                }
            };
        }
    },
    computed:{
        puzzleName(){
            if(this.gameType===1){
                return "拼圖一";
            }
            else if(this.gameType===2){
                return "拼圖二";
            }
            else{
                return "混合拼圖";
            }
        },
        puzzleDiff(){
            if(this.difficulty===1){
                return "簡單";
            }
            else if(this.difficulty===2){
                return "困難";
            }
            else if(this.gameType===3){
                return "高手";
            }
        },
        puzzleImage(){
            switch (this.gameType) {
                case 1:
                    return require('@/assets/img/diff-1.png');
                case 2:
                    return require('@/assets/img/diff-2.png');
                case 3:
                    return require('@/assets/img/diff-3-v2.png');
                default:
                    return null;
            }
        },
        isDesktop(){
            return window.innerWidth > 980;
        }
    },
    mounted(){
        this.getData();
        document.addEventListener("keydown", (e)=>{
            if(e.code==='Escape'){
                this.checkMaskClicked();
            }
        })
    },
    destroyed(){
        this.clearPhaserInstance();
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/main.scss';
</style>